<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">
          {{ labelBtn }} portal
        </v-card-title>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-form ref="formPortals">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :value="itemsForm.descricao"
                  @input="
                    ($event) => (itemsForm.descricao = $event?.toUpperCase())
                  "
                  label="Portal"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="itemsForm.url"
                  label="Endereço"
                  :rules="[rules.required, rules.checkURL]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <p class="font-weight-bold">Papeis</p>
            <p>Adicione os papeis que terão acesso a este portal.</p>
            <v-card class="pa-4 overflow-y-auto" outlined height="200px">
              <div v-for="(papel, index) in itemsForm.papeis" :key="index" class="d-flex align-center mb-4">
                
                <v-autocomplete
                  v-model="itemsForm.papeis[index]"
                  :items="getAvailableRoles(index)"
                  item-text="name"
                  item-value="id"
                  label="Papel Acesso"
                  class="flex-grow-1"
                  chips
                  required
                ></v-autocomplete>

                <v-btn icon color="red" @click="removePapel(index)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

              </div>
            </v-card>
            <v-btn class="mt-4" color="warning" width="100%" @click="addPapel">
              <v-icon left>mdi-plus</v-icon> Adicionar papel
            </v-btn>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="white--text btn-form"
          color="error"
          @click="closeModal()"
        >
          FECHAR
        </v-btn>
        <v-btn
          class="white--text mr-5 btn-form"
          :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
          @click="labelBtn == 'Cadastrar' ? createPortal() : updatePortal()"
        >
          {{ labelBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast";
import keycloak from "@/services/http/keycloak";
import portalAcessoPapeis from "@/services/http/rpa/PortalAcessoPapeis";
import senhas from "@/services/http/rpa/Senhas";
export default {
  props: {
    labelBtn: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {},
  },
  data: () => ({
    itemsForm: {
      descricao: "",
      url: "",
      papeis: [],
    },
    roles: [],
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
      checkURL: (value) =>
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www3\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
          value
        ) || "Endereço inválido",
    },
  }),
  mounted() {
    this.fetchRoles();
  },
  methods: {
    addPapel() {
      this.itemsForm.papeis.push(null); // adiciona um autocomplete vazio
    },

    removePapel(index) {
      this.itemsForm.papeis.splice(index, 1);
    },

    getAvailableRoles(index) {
      const selected = this.itemsForm.papeis.filter((id, i) => i !== index);
      return this.roles.filter((role) => !selected.includes(role.id));
    },
    async fetchRoles() {
      try {
        const response = await keycloak().list({});
        this.roles = response.data.raw;
      } catch (err) {
        toast("error", "Erro ao carregar as roles");
      }
    },

    updateValue(value) {
      this.itemsForm.descricao = value?.toUpperCase();
    },
    async closeModal() {
      this.$emit("update:dialog", false);
      // await this.$parent.fetchPortals();
      this.$refs.formPortals.reset();
      this.itemsForm.papeis = [];
    },
    async createPortal() {
      if (!this.$refs.formPortals.validate()) return;
      try {
        const response = await senhas().store(this.itemsForm);
        this.createPortalPapeis(response.data.id);
        
        toast("success", "Portal cadastrado!");
      } catch (err) {
        toast("error", "Erro inesperado");
      }
      this.$parent.fetchPortals();
      this.$parent.fetchLogins();
    },

    async createPortalPapeis(portalId) {
      try {
        const promises = this.itemsForm.papeis
          .filter((papelId) => !!papelId) // evita null/undefined
          .map((papelId) =>
            portalAcessoPapeis().store({
              id_portal: portalId,
              id_papel: papelId,
            })
          );

        await Promise.all(promises);
      } catch (err) {
        console.error(err);
        toast("error", "Erro ao associar papéis ao portal");
      }finally{
        this.closeModal();
      }
    },

    async updatePortal() {
      if (this.$refs.formPortals.validate()) {
        await senhas(this.selectedItem.id)
          .update(this.itemsForm)
          .then(() => {
            this.$swal("Sucesso", "Grupo alterado!", "success");
            this.closeModal();
          })
          .catch((err) => {
            this.$swal("Opa", "Algo não deu certo...", "error");
          });
      }
    },
  },
  watch: {
    async selectedItem(item) {
      this.itemsForm = {...item};
      this.itemsForm.papeis = this.itemsForm.papeis.map((papel) => papel.id_papel);
    },
  },
};
</script>
